import React from 'react';
import { Row, Col, Alert } from 'antd';
import EdenredHeader from '@pages/main-layout/components/main-header';
import ETypo from '@pages/DesignSystem/Typo';
import ContentLoader from '@sharedComponent/content-loader';
import Timingcard from './timingcard';
import PropTypes from 'prop-types';

const PayrollTimingsPresentational = ({ loading }) => {

	const staticPayrollTimingsWPS = [
		{ salaryfundrecieved: 'Salary Funds Received:', expectedPayout: 'Expected Payout:' },
		{ salaryfundrecieved: 'Before 9 AM', expectedPayout: '3 PM' },
		{ salaryfundrecieved: 'Before 11 AM', expectedPayout: '5 PM' },
		{ salaryfundrecieved: 'Before 1 PM', expectedPayout: '7 PM' },
		{ salaryfundrecieved: 'Before 4.30 PM', expectedPayout: '9 PM' },
		{ salaryfundrecieved: 'Before 5.30 PM ( Monday - Friday)', expectedPayout: '10 PM' },
	];

	const staticPayrollTimingsNonWPSC3Pay = [
		{ salaryfundrecieved: 'Salary Funds Received:', expectedPayout: 'Expected Payout:' },
		{ salaryfundrecieved: 'Before 4.30 PM', expectedPayout: '8 PM' },
	];

	const staticPayrollTimingsNonWPSBank = [
		{ salaryfundrecieved: 'Salary Funds Received:', expectedPayout: 'Expected Payout:' },
		{ salaryfundrecieved: 'Before 11:30 AM', expectedPayout: '4 PM' },
	];

	return (
		<>
			<EdenredHeader />
			{loading ? (
				<ContentLoader />
			) : (
				<Row className="payroll_timings_container">
					<Col xl={24} lg={24} md={24} sm={24} xs={24} className="payroll_timings_title">
						<ETypo h2 bold className="heading-color">
							Payroll Cut-off Timing
						</ETypo>
					</Col>
					<Col xl={24} lg={24} md={24} sm={24} xs={24} className="payroll_timings_card_section">
						<Alert
							message={
								<ETypo b2 lightx>
									Salaries are processed 6 days a week (Monday - Saturday), with the exception of public holidays.
								</ETypo>
							}
							type="info"
							showIcon
							className="payroll_timings_alert"
						/>
						<div className="wps-and-nonwps-section">
							<div className="payroll_timings_wps-nonwps_card">
								<ETypo h4 medium className="payroll_timings_card_title">
									WPS
								</ETypo>
								<Timingcard content={staticPayrollTimingsWPS} />
							</div>
							<div className="payroll_timings_wps-nonwps_card">
								<ETypo h4 medium className="payroll_timings_card_title">
									Non WPS C3Pay Accounts
								</ETypo>
								<Timingcard content={staticPayrollTimingsNonWPSC3Pay} type="PayrollTimings" />
							</div>
							<div className="payroll_timings_wps-nonwps_card">
								<ETypo h4 medium className="payroll_timings_card_title">
									Non WPS Bank Account
								</ETypo>
								<Timingcard content={staticPayrollTimingsNonWPSBank} type="PayrollTimings" />
							</div>
						</div>
					</Col>
				</Row>
			)}
		</>
	);
};

export default PayrollTimingsPresentational;

PayrollTimingsPresentational.propTypes = {
	loading: PropTypes.bool
};